export const spaceMap = {
  "1225": 1,
  "1225_2": 1,
  "4193": 1,
  "4849": 1,
  "4868": 1,
  "4870": 1,
  "20300": .5,
  "20301": .5,
  "20360": .5,
  "20361": .5,
  "20380": 1,
  "20400": .5,
  "20601": 1,
  "21002": 1,
  "21012": 1,
  "21013": 1,
  "21104AM": 1,
  "21108": 1,
  "21108-3": 1,
  "21108-8": 1,
  "21108-FB": 1,
  "21110": 1,
  "21111": 1,
  "21112": 1,
  "21113": 1,
  "21114": 1,
  "21115": 1,
  "21116": 1,
  "21117": 1,
  "21118": 1,
  "21119": 1,
  "21120": 1,
  "21121": 1,
  "21122": 1,
  "21123": 1,
  "21124": 1,
  "21125": 1,
  "21126": 1,
  "21127": 1,
  "21128": 1,
  "21129": 1,
  "21130": 1,
  "21131": 1,
  "21132": 1,
  "21133": 1,
  "21134": 1,
  "21135": 1,
  "21136": 1,
  "21137": 1,
  "21138": 1,
  "21139": 1,
  "21140": 1,
  "21141": 1,
  "21142": 1,
  "21143": 1,
  "21146": 1,
  "21150": 1,
  "21151": 1,
  "21156": 1,
  "21166": 1,
  "21168": 1,
  "21197": 1,
  "21201": 1,
  "21211": 1,
  "21216": 1,
  "21218": 1,
  "21230": 1,
  "21268": 1,
  "21269": 1,
  "21270": 1,
  "21271": 1,
  "213013": 1,
  "21480": 2,
  "21482": 2,
  "21483": 2,
  "21484": 2,
  "21486": 2,
  "21502AM": 1,
  "21504": 1,
  "21511": 1,
  "21512": 1,
  "21513": 1,
  "21514": 1,
  "21515": 1,
  "21516": 1,
  "21517": 1,
  "21521": 1,
  "21522": 1,
  "21523": 1,
  "21524": 1,
  "21526": 1,
  "21527": 1,
  "21531": 1,
  "21550": 1,
  "21560": 1,
  "21561": 1,
  "21562": 1,
  "21563": 1,
  "21564": 1,
  "21565": 1,
  "21566": 1,
  "21567": 1,
  "21568": 1,
  "21569": 1,
  "21570": 1,
  "21610": 2,
  "21612": 2,
  "21618": 2,
  "21620": 2,
  "21622": 2,
  "21623": 2,
  "21625": 2,
  "21626": 2,
  "21627": 2,
  "21628": 2,
  "21634": 2,
  "21642": 2,
  "21645": 2,
  "21648": 2,
  "21651": 3,
  "21652": 2,
  "21660": 2,
  "21661": 2,
  "21665": 2,
  "21701": 2,
  "21716": 2,
  "21750": 2,
  "21763": 2,
  "21765": 2,
  "21801": 2,
  "21811": 2,
  "21812": 2,
  "22010": 2,
  "22210": 2,
  "22216": 2,
  "22217": 2,
  "23300": 2,
  "23301": 2,
  "23302": 2,
  "23303": 2,
  "23304": 2,
  "23502": 2,
  "23515": 2,
  "23516": 2,
  "23517": 2,
  "23518": 2,
  "23523": 2,
  "23600": 2,
  "23601": 2,
  "23617": 2,
  "23618": 2,
  "23621": 2,
  "23622": 2,
  "23660": 2,
  "23663": 2,
  "23664": 2,
  "23665": 2,
  "23666": 2,
  "23751": 2,
  "23753": 3,
  "23754": 3,
  "23755": 3,
  "2704B": 3,
  "2704R": 3,
  "2704N": 3,
  "2704RY": 3,
  "31006": 4,
  "31013": 2,
  "36001": .5,
  "36002": .5,
  "36003": .5,
  "36004": .5,
  "36005": .5,
  "36006": .5,
  "40100": 2,
  "4016": 6,
  "4017": 6,
  "4054": 2,
  "4056": 2,
  "4059": 4,
  "4065": 4,
  "4069": 8,
  "4071": 2,
  "4116": 4,
  "4118": 4,
  "4122": 4,
  "4123": 4,
  "4129": 4,
  "4130": 4,
  "4131": 4,
  "4134": 6,
  "4135": 4,
  "4136": 4,
  "4182": 4,
  "4193": 4,
  "4250": 6,
  "4251": 6,
  "4253": 6,
  "4257": 6,
  "4278": 6,
  "4279": 6,
  "4302": 2,
  "4849": 2,
  "4868": 2,
  "4870": 2,
  "5001": 8,
  "54404": 2,
  "54405": 2,
  "56601": 3,
  //"56601": 3,
  //"56601": 3,
  "56602": 3,
  "56607": 3,
  "56800": 3,
  "56801": 3,
  "58080": 4,
  "58081": 4,
  "5881": 4,
  "5882": 4,
  "59000": 4,
  "59000-1": 4,
  "59001": 4,
  "59002": 4,
  "59004": 4,
  "59005": 4,
  "59005-G": 4,
  "59006": 4,
  "59006-1": 4,
  "59021": 4,
  "59022": 4,
  "59100": 4,
  "59101": 4,
  "5996": 4,
  "5997": 4,
  "61000": 4,
  "67500": 4,
  "6507S": 6,
  "6630B": 6,
  "71221": 2,
  "71222": 2,
  "71223": 3,
  "71231": 2,
  "71232": 3,
  "71233": 3,
  "71441": 2,
  "71442": 2,
  "71443": 2,
  "71445": 2,
  "71661": 3,
  "71662": 3,
  "71665": 3,
  "71681": 3,
  "71682": 3,
  "71685": 3,
  "72011": 4,
  "72012": 4,
  "72021": 4,
  "72030": 2,
  "72031": 2,
  "72032": 2,
  "72039": 2,
  "72040": 4,
  "72041": 4,
  "72042": 6,
  "72043": 6,
  "72050": 4,
  "721769": 2,
  "726009": 2,
  "726019": 2,
  "726029": 2,
  "726039": 2,
  "726049": 2,
  "726059": 2,
  "726069": 2,
  "73600": 3,
  "76000": 4,
  "76001": 6,
  "76001": 8,
  "76002": 8,
  "76003": 8,
  "76004": 8,
  "76005": 6,
  "80305": 1,
  "80306": 1,
  "80307": 1,
  "80500": 1,
  "80510": 24,
  "81002": .1,
  "81003": .1,
  "81100": .1,
  "82001": .1,
  "82003": .1,
  "83001": .1,
  "84001": .1,
  "84002": .1,
  "84004": .5,
  "84005": 1,
  "84006": 1,
  "84007": 1,
  "84008": 1,
  "84010": 1,
  "84400": .5,
  "84400-2": .5,
  "85016": .5,
  "85047": .5,
  "85055": .5,
  "85061": .5,
  "85082": .5,
  "850G": .5,
  "87004": 2,
  "87007": 2,
  "87008": 2,
  "87009": 2,
  "87015": 2,
  "87016": 2,
  "89007": 10,
  "89110": 10,
  "90001": 1,
  "91096": 3,
  "91097": 4,
  "91098": 2,
  "91099-T": 2,
  "91100": 2,
  "91100-T": 2,
  "91101-T": 2,
  "91102-T": 2,
  "91101": 2,
  "91102": 2,
  "91103": 2,
  "91200": 2,
  "91201": 2,
  "91205": 1,
  "91241": 4,
  "91289": 2,
  "91299": 1,
  "91321": .5,
  "91322": .5,
  "91324": .5,
  "93105": 4,
  "915": 1,
  "920": 2,
  "914494": 1,
  "914496": 1,
  "91600": 4,
  "91601": 4,
  "91602": 4,
  "91603": 4,
  "93105": 6,
  //"932": .5,
  "942": 1,
  "123456": 1,
  "1225_2": 2,
  "21104AM": 1,
  "21108-FB": 1,
  "21502AM": 1,
  "2366X": 2,
  "2375X": 2,
  "932": .1,
  "6507S": 4,
  "BARAPRON": 3,
  "CMF": 8,
  "DT001": 1,
  "FJX-TX115": 4,
  "FJX-XMAS": 4,
  "FJX-XMAS": 4,
  "FRAMH1": 3,
  "GIFT46": 2,
  "GIFT68": 4,
  "H-7001": 6,
  "H1192": 6,
  "HUG6": 2,
  "INSERT11X17": 8,
  "INSERT8X11": 6,
  "IYP-APA": 4,
  "IYP-933": .1,
  "IYP-931": .1,
  "IYP-932": .1,
  "IYP-933": .1,
  "IYP-PB": 24,
  "IYP-SC2533": 4,
  "M103PD-BLK": 2,
  "M103PD-BLU": 2,
  "M103PD-SIL": 2,
  "M104PD-BLK": 2,
  "MPB001": 3,
  "MR013": 3,
  "Ncube": 1,
  "PCJumbo": 1,
  "PCPinkPoker": 1,
  "PCPoker": 1,
  "Pillow1818W": 10,
  "Pillow2222W": 10,
  "POS1013": 4,
  "POS1114": 4,
  "POS1620": 4,
  "POS1824": 6,
  "POS2030": 6,
  "POS2436": 6,
  "PS1824": 6,
  "PS2436": 6,
  "POSTER-L": 6,
  "POSTER-M": 4,
  "POSTER-S": 4,
  "PS1824A": 8,
  "PS2436A": 12,
  "PUZ110BOX": 3,
  "PUZ252TIN": 3,
  "PUZ30BOX": 3,
  "RTIN": 2,
  "TRAY1120": 6,
  "TRAY8X11": 6,
  "TRAY1120": 8,
  "TUMBLER": 2,
  "U1004": 4,
  "U5507": .5,
  "U5507_2sided": .5,
  "U5524_2sided": .5,
  "U5607": 6,
  "U5646": .5,
  "U5689": 4,
  "U5672": 8,
  "U5955": 6,
  "U5859": 4,
  "U5969": 4,
  "WINE1": 2,
  "WINE2": 2,
  "WP230CH": 8,
  "WP520CH": 15,
  "Yogamat1": 8,
  "Z91268": 1,
  "Z91269": 1,
  "Z91270": 1,
  "Z91271": 1,
  "Z91272": 1,
  "Z91273": 1,
  "Z91274": 1,
}